import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0896a904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invention-authorization" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "排名"),
  /*#__PURE__*/_createElementVNode("span", { style: {"flex":"4"} }, "权利人名称"),
  /*#__PURE__*/_createElementVNode("span", null, "专利申请总量"),
  /*#__PURE__*/_createElementVNode("span", null, "发明专利有效量"),
  /*#__PURE__*/_createElementVNode("span", null, "实用新型有效量")
], -1))
const _hoisted_3 = { style: {"flex":"4"} }

import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'RankingCpn',
  setup(__props) {

let scrolltimer = 0
const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const scrolltRef = ref<HTMLElement>()

watch(
    () => data.value,
    (v) => {
        if (scrolltimer) return

        if (v) {
            console.log(1);

            automaticScrolling()
        }
    },
    { flush: "post" }
)
onMounted(() => {
    console.log(2);

    automaticScrolling()
})
onUnmounted(() => {
    clearInterval(scrolltimer)
})
const automaticScrolling = () => {
    if (scrolltRef.value) {
        console.log(scrolltRef.value.scrollHeight, scrolltRef.value.clientHeight);

        if (scrolltRef.value.scrollHeight <= scrolltRef.value.clientHeight) {
            console.log(scrolltRef.value, 333)
            return
        }
        scrolltimer = setInterval(() => {
            if (scrolltRef.value) {
                if (scrolltRef.value.scrollTop >= scrolltRef.value.scrollHeight - scrolltRef.value.clientHeight) {
                    scrolltRef.value.scrollTo(0, 0)
                }
                scrolltRef.value.scrollTo(0, scrolltRef.value.scrollTop + 1)
            }
        }, 100)
    }
}

const handleMouseEnter = () => {
    clearInterval(scrolltimer)
}

const handleMouseLeave = () => {
    automaticScrolling()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "content",
      ref_key: "scrolltRef",
      ref: scrolltRef,
      onMouseenter: handleMouseEnter,
      onMouseleave: handleMouseLeave
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data)?.midBotton, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: item.id
        }, [
          _createElementVNode("span", null, _toDisplayString(item.ranking), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1),
          _createElementVNode("span", null, _toDisplayString(item.totalApplicationAmount), 1),
          _createElementVNode("span", null, _toDisplayString(item.inventionEffectiveQuantity), 1),
          _createElementVNode("span", null, _toDisplayString(item.effectiveAmountOfUtility), 1)
        ]))
      }), 128))
    ], 544)
  ]))
}
}

})